export class PhoneEvent {
  constructor(
    public extension: string,
    public phone: string,
    public completePhone: string
  ) {}
}
